import React from 'react';
import './LocationPicker.css';

const LocationPicker = ({
  locations = [],
  selectedLocationId = '',
  onSelect,
  title = 'Choose a location',
  subtitle = 'Select where you would like your appointment.',
}) => {
  if (!locations.length) {
    return (
      <div className="location-picker">
        <p className="location-picker__empty">No locations are available for booking right now.</p>
      </div>
    );
  }

  return (
    <div className="location-picker">
      <div className="location-picker__header">
        <h2>{title}</h2>
        {subtitle ? <p>{subtitle}</p> : null}
      </div>
      <div className="location-picker__grid">
        {locations.map((location) => {
          const selected = selectedLocationId === location.id;
          return (
            <button
              key={location.id}
              type="button"
              className={`location-picker__card${selected ? ' is-selected' : ''}`}
              onClick={() => onSelect?.(location)}
            >
              <span className="location-picker__name">{location.name}</span>
              {location.address?.fullAddress ? (
                <span className="location-picker__address">{location.address.fullAddress}</span>
              ) : null}
              {location.phone ? <span className="location-picker__phone">{location.phone}</span> : null}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default LocationPicker;
